import { faDownload } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Tooltip } from "antd";
import { bool, object, string } from "prop-types";
import { useState } from "react";
import { useIntl } from "react-intl";

const DownloadAll = ({ iconOnly, tooltip, disabled, type, id }) => {
  const intl = useIntl();

  // local state
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadAll = (e) => {
    e.stopPropagation();
    setIsDownloading(true);

    //TODO: Create logic for downloading all attachments
  };

  return (
    <Tooltip title={tooltip} style={{ display: tooltip ? "block" : "hidden" }}>
      <Button
        data-test-id="download-all-download-button"
        icon={<FontAwesomeIcon icon={faDownload} />}
        loading={isDownloading}
        onClick={downloadAll}
        key={"download-button"}
        disabled={disabled}
        type={type}
        id={id}
      >
        {iconOnly !== true && (
          <span>
            {intl.formatMessage({
              id: "partDetails.downloadAllAttachments",
            })}
          </span>
        )}
      </Button>
    </Tooltip>
  );
};

DownloadAll.propTypes = {
  request: object,
  part: object,
  iconOnly: bool,
  tooltip: string,
  disabled: bool,
  type: string,
  id: string,
};

export { DownloadAll };
